<template>
  <md-button
    @click="onClick"
    class="button"
    :class="{ 'disabled-button': disabled }"
    :disabled="disabled"
  >
    <span v-if="!loading" class="text">{{ text }}</span>
    <span v-else>
      <LoadSpinner color="white" />
    </span>
  </md-button>
</template>

<script>
import LoadSpinner from '@/components/LoadSpinner'
export default {
  name: 'LoadingSpinnerButton',
  components: {
    LoadSpinner,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  methods: {
    onClick() {
      this.$emit('click')
    },
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
.button {
  @include primary-button(var(--dark-brand-color));
}
.disabled-button {
  @include primary-button-disabled();
}
.text {
  font-size: 0.9rem;
  font-weight: 100;
}
</style>
